import type { ReactElement } from 'react'

import { useTranslate } from '../../code-only/localization/index.ts'
import { Avatar, Button } from '../../components/index.ts'
import { colorTokens } from '../../foundations/index.ts'

type HeaderContactButtonProps = { onContact: () => void }

export function HeaderContactButton({ onContact }: HeaderContactButtonProps): ReactElement {
  const translate = useTranslate()
  return (
    <Button
      variant="secondary"
      onClick={onContact}
      avatar={
        <Avatar
          icon="comment-regular"
          color={colorTokens['color-fg-base-active-inverse']}
          secondaryColor={colorTokens['color-fg-base-active-inverse']}
        />
      }
      size="medium"
      avatarPosition="left"
      trackingId="contact_button"
    >
      {translate('contact_customer_support')}
    </Button>
  )
}
